import { defineStore } from 'pinia'
import { ref, type Component, useId, shallowRef, type ShallowRef } from 'vue';

export type TToastStatus = 'success' | 'error';

export interface IToast<T = any> {
    id: string,
    status: TToastStatus,
    content: Component<T>,
    props?: T
}

export interface IToastStore<T> extends IToast<T> {
    content: ShallowRef<Component<T>>,
}

const TIMEOUT = 3000;

export const useToastStore = defineStore('toast', () => {
    const toasts = ref<IToast[]>([]);

    const addToast = ({ content, ...toast }: Omit<IToast, 'id'>) => {
        const id = crypto.randomUUID();

        toasts.value.push({ content: shallowRef(content), ...toast, id });

        setTimeout(() => {
            toasts.value = toasts.value.filter((t) => t.id !== id);
        }, TIMEOUT);
    }

    const closeToast = (toast: IToast) => {
        toasts.value = toasts.value.filter(t => t.id !== toast.id)
    }

    return {
        toasts,

        addToast,
        closeToast
    }
});